import { render, staticRenderFns } from "./pageKazNIISA.vue?vue&type=template&id=ddb158fe&scoped=true"
import script from "./pageKazNIISA.vue?vue&type=script&lang=js"
export * from "./pageKazNIISA.vue?vue&type=script&lang=js"
import style0 from "./pageKazNIISA.vue?vue&type=style&index=0&id=ddb158fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb158fe",
  null
  
)

export default component.exports